export { setDefaultNode, getDefaultNode } from './RootNode';